import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import IELTSlogo from '../assets/Logos/IELTSlogo.png';
import HEXASLogo from '../assets/Logos/HEXASLogo.jpg';
import CambridgeAssessmentLogo from '../assets/Logos/CambridgeAssessmentLogo.png';
import BritishCouncilLogo from '../assets/Logos/BritishCouncilLogo.png';
import IDPLogo from '../assets/Logos/IDPLogo.png';

const ListeningInstruction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const target = location.state?.target;

  const handleStartTest = () => {
    if (target) {
      navigate(target);
    } else {
      console.error("No target provided!");
    }
  };

  return (
    <div className="min-h-screen bg-[#D7DFEC] font-[Arial]">
      {/* Logos Row */}
      <div className="w-full flex flex-row items-center justify-between py-4 px-8 bg-white">
        <img src={IELTSlogo} alt="IELTS Logo" className="h-12 object-contain transform scale-90" />
        <img src={HEXASLogo} alt="Hexas Logo" className="h-14 object-contain" />
        <img src={CambridgeAssessmentLogo} alt="IELTS Partners" className="h-14 object-contain transform scale-125" />
        <img src={BritishCouncilLogo} alt="IELTS Partners" className="h-12 object-contain" />
        <img src={IDPLogo} alt="IELTS Partners" className="h-12 object-contain" />
      </div>

      {/* Top Bar */}
      <div className="relative h-[32px] bg-gray-800 border-b border-gray-700 flex items-center justify-between px-4 overflow-hidden">
        {/* White soft highlighter effect */}
        <div
          className="absolute pointer-events-none"
          style={{
            top: '10%',
            bottom: '10%',
            left: 0,
            right: 0,
            background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.18) 50%, rgba(255,255,255,0) 100%)',
            backdropFilter: 'blur(6px)',
            zIndex: 0,
          }}
        ></div>

        {/* Left: User Info */}
        <div className="w-1/3 flex items-center z-10">
          <span className="text-[12px] text-[#CCCCCC] font-medium">
            <span className="mr-1">👤</span>
            HEXAS'S Education
          </span>
        </div>
      </div>

      {/* Main content */}
      <div className="w-full px-4 py-6 flex justify-center">
        <div className="bg-[#E3E9F0] rounded border border-[#A0A9B8] shadow-sm p-6 w-full -mt-3 -mx-10 max-w-[1600px] h-[450px]">
          <h1 className="text-[20px] font-bold text-black mb-4">IELTS Listening</h1>

          <div className="space-y-3 text-left">
            <div>
              <p className="text-black text-[16px]">Time: Approximately 30 minutes</p>
            </div>

            <div>
              <h2 className="text-[16px] font-bold text-black mb-2">INSTRUCTIONS TO CANDIDATES</h2>
              <ul className="list-disc pl-6 space-y-0.5 text-black text-[16px]">
                <li>Answer <span className="font-bold">all</span> the questions.</li>
                <li>You can change your answers at any time during the test.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-[16px] font-bold text-black mb-2">INFORMATION FOR CANDIDATES</h2>
              <ul className="list-disc pl-6 space-y-0.5 text-black text-[16px]">
                <li>There are 40 questions in this test.</li>
                <li>Each question carries one mark.</li>
                <li>There are 4 parts to the test.</li>
                <li>You will hear each part once.</li>
                <li>For each part of the test there will be time for you to look through the questions and time for you to check your answers.</li>
              </ul>
            </div>
          </div>

          {/* Footer Note & Start Button */}
          <div className="pt-3 flex flex-col items-center">
            <button
              onClick={handleStartTest}
              className="bg-[#F8F9FA] font-semibold text-black px-5 py-1.5 rounded text-[13px] border border-[#A0A9B8] hover:bg-[#F0F2F4] transition-colors shadow-sm"
            >
              Start test
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListeningInstruction;
